import React, { useEffect, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import Box from '@mui/material/Box';
import { useForm } from 'react-hook-form';
import Pagination from '@mui/material/Pagination';
import Container from '@mui/material/Container';
import DateAdapter from '@mui/lab/AdapterMoment';
import DatePicker from '@mui/lab/DatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

const columns = [
  { id: 'rowNumber', label: 'No', minWidth: 40, align: 'center' },
  { id: 'apiNm', label: 'API 명', minWidth: 200, align: 'center' },
  { id: 'shortCut', label: '단축어', minWidth: 300, align: 'center' },
  { id: 'apiKey', label: 'API 키', minWidth: 300, align: 'center' },
  { id: 'dueDate', label: '만료일', minWidth: 300, align: 'center' }
];

export default function ApiKeyMng() {
  const [srchData, setSrchData] = useState({});
  const [datas, setDatas] = useState({ viewYn: false });
  const [rows, setRows] = useState([]);
  const [pageCnt, setPageCnt] = useState(1);
  const [page, setPage] = useState(1);
  const [offset] = useState(10);
  const [dueDate, setDueDate] = useState();

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    formState: { errors, isDirty }
  } = useForm({
    mode: 'all'
  });

  const handleChangeSrch = (e) => {
    let id = e.target.id.replace('Srch', '');
    setSrchData({ ...srchData, [id]: e.target.value });
  };

  const handleChange = (e) => {
    setDatas({ ...datas, [e.target.id]: e.target.value });
  };

  const handleRowClick = (data) => (evt) => {
    initForm();
    setDatas(data);
    setDueDate(data.dueDate);
    setValue('datas', data);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const getDataList = async (e) => {
    const { pgmNm } = srchData;
    let params = {
      offset,
      page,
      limit: offset,
      pgmNm
    };

    const response = await axios.get(`/api/key`, { params });
    if (response.data) {
      const result = response.data;
      setPageCnt(Math.ceil(result.count / offset));
      setRows(result.rows);
      if (e?.target) {
        setPage(1);
      }
    }
  };

  const onClickInit = (evt) => {
    initForm();
  };

  const initForm = () => {
    setDatas({});
    setDueDate('');
    clearErrors();
    reset();
  };

  const ApiKeyMngCreate = async (data) => {
    data.dueDate = typeof dueDate === 'string' ? dueDate : dueDate?.format('YYYY-MM-DD');
    return await axios.post(`/api/key`, data);
  };

  const ApiKeyMngUpdate = async (data) => {
    data.dueDate = typeof dueDate === 'string' ? dueDate : dueDate?.format('YYYY-MM-DD');
    return await axios.patch(`/api/key/${data.id}`, data);
  };

  const onClickDelete = async (evt) => {
    try {
      if (datas?.id) {
        await axios
          .delete(`/api/key/${datas.id}`)
          .then((response) => {
            getDataList();
            initForm();
            alert(response.data.message);
          })
          .catch((error) => {
            alert(error.response.data.message);
          });
      }
    } catch (e) {
      console.log(`insert failed`);
    }
  };

  const createOrUpdate = async (datas) => {
    if (!!datas?.id) {
      return await ApiKeyMngUpdate(datas);
    } else {
      return await ApiKeyMngCreate(datas);
    }
  };

  const onSubmit = (data) => {
    if (isDirty) {
      createOrUpdate(data.datas)
        .then((response) => {
          getDataList();
          initForm();
          alert(response.data.message);
        })
        .catch((error) => {
          console.log(error);
          alert(error.response.data.message);
        });
    }
  };

  useEffect(() => {
    getDataList(page);
  }, [page]);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        API KEY 관리
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <Stack direction="row" spacing={2}>
            <TextField id="pgmNmSrch" variant="outlined" size="small" label="사이트" value={srchData?.pgmNm || ''} onChange={handleChangeSrch} />
            <Button variant="contained" onClick={getDataList}>
              검색
            </Button>
          </Stack>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, rowIdx) => (
                  <TableRow hover key={row.id} onClick={handleRowClick(row)}>
                    {columns.map((col, colIdx) => {
                      return (
                        <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                          {row[col.id]}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Container maxWidth="sm" sx={{ mt: 2 }}>
              <Pagination count={pageCnt} page={page} onChange={handleChangePage} showFirstButton showLastButton />
            </Container>
          </TableContainer>
        </Grid>
        <Grid item xs={3}>
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="contained" onClick={onClickInit}>
              초기화
            </Button>
            <Button variant="contained" type="submit" form="ApiKeyMngForm" disabled={isDirty && JSON.stringify(datas) !== '{}' ? false : true}>
              {!!datas?.id ? '수정' : '등록'}
            </Button>
            <Button variant="contained" onClick={onClickDelete} disabled={datas?.id ? false : true}>
              삭제
            </Button>
          </Stack>
          <Box id="ApiKeyMngForm" component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1, minWidth: 300, maxWidth: 500 }}>
            <TextField
              margin="dense"
              required
              fullWidth
              name="apiNm"
              label="API 명"
              id="apiNm"
              value={datas?.apiNm || ''}
              error={!!errors.datas?.apiNm}
              helperText={errors.datas?.apiNm && errors.datas?.apiNm.message}
              {...register('datas.apiNm', {
                required: 'API명을 입력해주세요.',
                onChange: (e) => handleChange(e)
              })}
            />
            <TextField
              margin="dense"
              required
              fullWidth
              name="shortCut"
              label="단축어"
              id="shortCut"
              value={datas?.shortCut || ''}
              error={!!errors.datas?.shortCut}
              helperText={errors.datas?.shortCut && errors.datas?.shortCut.message}
              {...register('datas.shortCut', {
                required: '단축어를 입력해주세요.',
                onChange: (e) => handleChange(e)
              })}
            />
            <TextField
              margin="dense"
              required
              fullWidth
              name="apiKey"
              label="API 키"
              id="apiKey"
              value={datas?.apiKey || ''}
              error={!!errors.datas?.apiKey}
              helperText={errors.datas?.apiKey && errors.datas?.apiKey.message}
              {...register('datas.apiKey', {
                required: 'API 키를 입력해주세요.',
                onChange: (e) => handleChange(e)
              })}
            />
            <LocalizationProvider dateAdapter={DateAdapter}>
              <DatePicker
                inputFormat={'yyyy-MM-DD'}
                value={dueDate || null}
                valueDefault={null}
                onChange={(newValue) => {
                  setValue('dueDate', newValue, { shouldDirty: true });
                  setDueDate(newValue);
                }}
                label="만료일"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    error={!!errors.dueDate}
                    helperText={errors.dueDate && errors.dueDate.message}
                    {...register('dueDate', {
                      pattern: { value: /\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])/, message: '날짜 형식(YYYY-MM-DD)을 맞춰주세요' }
                    })}
                  />
                )}
                disableMaskedInput={true}
                disablePast={true}
              />
            </LocalizationProvider>
            <TextField
              margin="dense"
              fullWidth
              name="url"
              label="URL"
              id="url"
              value={datas?.url || ''}
              error={!!errors.datas?.url}
              helperText={errors.datas?.url && errors.datas?.url.message}
              {...register('datas.url', {
                onChange: (e) => handleChange(e)
              })}
            />
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}
